import { TFunction } from "i18next";

export const getChipName = (t: TFunction, name: string) => {
  const chipNames: Record<string, string> = {
    bboost: t("chips:benchBoost", "Bench Boost"),
    "3xc": t("chips:tripleCaptain", "Triple Captain"),
    freehit: t("chips:freeHit", "Free Hit"),
    wildcard: t("chips:wildcard", "Wildcard"),
  };
  return chipNames[name] || "";
};
